var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.loaded)?[(_vm.isAnEventCalendar || _vm.isBusinessItems)?_c('SearchAPI'):_c('Search')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }